import { useEffect, useState, createContext, useContext } from 'react';
import { connectSocket, disconnectSocket } from './socketIo';
import { useSelector } from 'react-redux';

const SocketContext = createContext({
  dataSpot: null,
  newSpot: null,
  spotStatusChange: null,
  lastMessage: null,
  isConnected: false,
});

export function SocketProvider({ children }) {
  const [dataSpot, setDataSpot] = useState(null);
  const [lastMessage, setLastMessage] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [newSpot, setNewSpot] = useState(null);
  const [spotStatusChange, setSpotStatusChange] = useState(null);

  const accessToken = useSelector((state) => state.currentUser?.accessToken);

  useEffect(() => {
    if (!accessToken) return; // بدون توكن لا يوجد اتصال

    const socket = connectSocket(accessToken);
    if (!socket) return;

    const onConnect = () => {
      setIsConnected(true);
      console.warn('___socket connected', socket?.id);
    };
    const onDisconnect = () => {
      setIsConnected(false);
      console.warn('socket disconnected');
    };
    const onConnectError = (err) => console.error('connect_error', err.message);

    // الحدث الوحيد يلي بيجي من السيرفر
    const onAppMessage = (payload) => {
      console.warn('app_message', payload);
      setLastMessage(payload);
      switch (payload?.type) {
        case 'spot':
          console.log('payload1', payload)
        case 'parking':
          console.log('payload2', payload)
          setDataSpot(payload?.data);
          break;
        default:
          break;
      }
    };

    const onParkingSpotNew = (spot) => {
      console.warn('parking_spot_new', spot);
      setNewSpot(spot);
    };

    const onParkingSpotStatusChange = (payload) => {
      console.warn('parking_spot_status_change', payload);
      setSpotStatusChange(payload);
    };

    const onDbChange = (payload) => {
      console.warn('Database change via socket:', payload);
      if (payload?.success && payload.data?.parking_spots) {
        const listChanges = payload.data.parking_spots.listChanges;
        if (Array.isArray(listChanges) && listChanges.length > 0) {
          const spot = listChanges[0];
          // Determine if it's a new spot or status change based on status
          // If status is AVAILABLE, it's a new spot
          if (spot.status === 1) { // 1 = AVAILABLE
            setNewSpot(spot);
          } else {
            // Status changed (PARKED or CANCELLED)
            let statusText = spot.status === 2 ? 'PARKED' : spot.status === 3 ? 'CANCELLED' : '';
            if (spot.status === 0) statusText = 'CANCELLED';
            if (statusText) {
                setSpotStatusChange({ idKey: spot.idKey, status: statusText });
            }
          }
        }
      }
    };

    socket?.on('connect', onConnect);
    socket?.on('disconnect', onDisconnect);
    socket?.on('connect_error', onConnectError);
    socket?.on('app_message', onAppMessage);
    socket?.on('parking_spot_new', onParkingSpotNew);
    socket?.on('parking_spot_status_change', onParkingSpotStatusChange);
    socket?.on('saffa_main', onDbChange);

    return () => {
      // تنظيف كامل عند unmount أو تغير التوكن
      socket?.off('connect', onConnect);
      socket?.off('disconnect', onDisconnect);
      socket?.off('connect_error', onConnectError);
      socket?.off('app_message', onAppMessage);
      socket?.off('parking_spot_new', onParkingSpotNew);
      socket?.off('parking_spot_status_change', onParkingSpotStatusChange);
      socket?.off('saffa_main', onDbChange);
      disconnectSocket();
    };
  }, [accessToken]);

  return (
    <SocketContext.Provider value={{ dataSpot, newSpot, spotStatusChange, lastMessage, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
}

export default function useSocket() {
  return useContext(SocketContext);
}
